export default "__VITE_ASSET__387b7db4__"